import React, { Component } from 'react';
import Table from '../../Table/Table';
import {
    fetchUrl,
    getUsers as fetchUsers
} from '../userManagementActions';
import {
    getCount,
    getIsDeleteUserSuccessful,
    getIsUsersLoading,
    getPages,
    getUsers,
    getUsersErrorMessage
} from '../userManagementEntity';
import FilterWithMapper from '../../Table/Filters/FilterWithMapper/FilterWithMapper';
import ListItem from './ListItem/ListItem';
import { getIsCreateUserSuccessful, getIsEditUserSuccessful } from '../userManagementEntity';
import { connect } from 'react-redux';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import PropTypes from 'prop-types';
import { getRoles } from '../userManagementEntity';
import { roleShape } from '../../../utils/propTypes';
import _ from 'lodash';
import { toggleModal } from '../../Modal/modalActions';
import { getIsNexioAgreementAccepted } from '../../AccountAgreement/accountAgreementEntity';

export const userRoleMapper = {
    A: 'Administrator',
    W: 'Standard',
    R: 'View Only'
};

export class Users extends Component {
    static propTypes = {
        renderHeaderComponent: PropTypes.func,
        isCreateUserSuccessful: PropTypes.bool,
        roles: PropTypes.arrayOf(roleShape),
        users: PropTypes.array,
        wasNexioAgreementJustAccepted: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {
            needsRefetch: false,
            wasNexioAgreementJustAccepted: this.props.wasNexioAgreementJustAccepted
        };

        this.defaultColumnsAndProps = [
            {
                accessor: 'userName',
                className: ['cursor-pointer'],
                defaultSortDesc: true,
                label: 'User Name',
                minWidth: 150,
                show: true,
                sortable: true
            },
            {
                accessor: 'firstName',
                className: ['cursor-pointer'],
                label: 'First Name',
                minWidth: 120,
                show: true,
                sortable: true
            },
            {
                accessor: 'lastName',
                className: ['cursor-pointer'],
                label: 'Last Name',
                minWidth: 120,
                show: true,
                sortable: true
            },
            {
                accessor: 'accessRights.merchantIds',
                className: ['cursor-pointer'],
                Cell: (props = {}) => Object.keys(props.value || {}).join(', '),
                label: 'Merchants',
                minWidth: 300,
                show: true,
                sortable: false
            },
            {
                accessor: 'role',
                className: ['cursor-pointer'],
                Cell: (props = {}) => (this.getUserRole(props.original)),
                Filter: ({ filter, onChange }) => (<FilterWithMapper
                    filter={filter}
                    mapper={this.getUserRolesObject()}
                    onChange={onChange}
                />),
                label: 'Role',
                minWidth: 120,
                show: true,
                sortable: false
            }
        ];
    }

    componentDidUpdate(previousProps) {
        const env = process.env.BUILD_ENV;

        if (env !== 'production' && doesPropExistAndHasItChanged(previousProps, this.props, 'users') && this.state.wasNexioAgreementJustAccepted) {
            const users = this.props.users.filter((u) => u.isApiUser);
            if (users[0]) {
                this.selectApiUser(users[0]);
            }
            this.setState({ wasNexioAgreementJustAccepted: false });
        }
        if (
            (doesPropExistAndHasItChanged(previousProps, this.props, 'isCreateUserSuccessful') && this.props.isCreateUserSuccessful)
            || (doesPropExistAndHasItChanged(previousProps, this.props, 'isEditUserSuccessful') && this.props.isEditUserSuccessful)
            || (doesPropExistAndHasItChanged(previousProps, this.props, 'isDeleteUserSuccessful') && this.props.isDeleteUserSuccessful)
        ) {
            this.refetchData();
        }
    }

    getUserRolesObject = () => {
        const userRolesObj = {};
        if (this.props.roles) {
            this.props.roles.forEach((role) => {
                if (!userRolesObj[role.name]) {
                    userRolesObj[role.role] = role.name;
                }
            });
        }

        return _.merge({}, userRolesObj, userRoleMapper);
    };

    selectUser = (history, user) => {
        this.props.editUser(user);
    };

    selectApiUser = (user) => {
        this.props.editUser(user);
    };

    getUserRole = (user) => {
        if (user.isApiUser) {
            return 'API User';
        }
        const userRole = _.get(user, 'role') || _.get(user, 'accessRights.role');
        const roleInfo = this.props.roles.find((role) => {
            return role.role === userRole;
        }) || {};

        return userRoleMapper[userRole] || roleInfo.name || null;
    };

    resetNeedsRefetch = () => {
        this.setState({ needsRefetch: false });
    };

    refetchData = () => {
        this.setState({ needsRefetch: true });
    };

    render() {
        return (
            <Table
                fetchUrl={fetchUrl}
                className="emvio-users-table"
                defaultColumnsAndProps={this.defaultColumnsAndProps}
                defaultSorted={[{
                    desc: false,
                    id: 'userName'
                }]}
                fetchData={fetchUsers}
                filterable={true}
                countSelector={getCount}
                dataSelector={getUsers}
                errorMessageSelector={getUsersErrorMessage}
                isDataLoadingSelector={getIsUsersLoading}
                pagesSelector={getPages}
                HeaderComponent={this.props.renderHeaderComponent}
                itemKey="userName"
                ListItemComponent={ListItem}
                needsRefetch={this.state.needsRefetch}
                noDataText="No Users Found"
                resetNeedsRefetch={this.resetNeedsRefetch}
                selectRow={this.selectUser}
                shouldHideCardPadding
                shouldHideDateRange
                shouldHideExport
                uniqueTableName="Users"
                hidePageSizeSelect
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        isCreateUserSuccessful: getIsCreateUserSuccessful(state),
        isEditUserSuccessful: getIsEditUserSuccessful(state),
        isDeleteUserSuccessful: getIsDeleteUserSuccessful(state),
        roles: getRoles(state),
        users: getUsers(state),
        wasNexioAgreementJustAccepted: getIsNexioAgreementAccepted(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        editUser: (user) => {
            dispatch(toggleModal('editUser', user));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);
